import { useState, useEffect } from 'react';
import { supabase } from '../config/supabaseClient';
import { products as staticProducts } from '../data/products';

function mapRowToProduct(row) {
  if (!row) return null;
  return {
    id: Number(row.id),
    name: row.name || row.title || '',
    shortName: row.short_name || row.shortName || row.short || '',
    category: row.category || '',
    concern: row.concern || row.concerns || [],
    price: Number(row.price) || 0,
    originalPrice: Number(row.original_price ?? row.originalPrice) || Number(row.mrp) || 0,
    size: row.size || '',
    rating: Number(row.rating) || 0,
    reviews: Number(row.reviews) || 0,
    badge: row.badge || null,
    description: row.description || '',
    ingredients: row.ingredients || [],
    howToUse: row.how_to_use || row.howToUse || '',
    benefits: row.benefits || [],
    suitableFor: row.suitable_for || row.suitableFor || [],
    image: row.image || (row.images && row.images[0]) || '',
    images: row.images || [],
  };
}

export function useProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('products')
          .select('*')
          .order('id', { ascending: true });

        if (fetchError) {
          console.warn('Supabase fetch error, falling back to static data:', fetchError.message || fetchError);
          if (!mounted) return;
          setProducts(staticProducts);
          setError(fetchError.message || String(fetchError));
        } else if (data && data.length > 0) {
          // Map DB rows (snake_case) to the shape components expect (camelCase)
          const mapped = data.map(mapRowToProduct);
          if (!mounted) return;
          setProducts(mapped);
        } else {
          console.log('No products found in Supabase; using static data');
          if (!mounted) return;
          setProducts(staticProducts);
        }
      } catch (err) {
        console.error('Error in useProducts fetch:', err);
        if (!mounted) return;
        setProducts(staticProducts);
        setError(err.message || String(err));
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    };

    fetchProducts();

    return () => { mounted = false; };
  }, []);

  return { products, loading, error };
}
